import { Moment } from 'moment';
import { DayOfWeek } from '@/shared/models/common';
import { PlannerResourceId } from './ids';

export default class Break {
  resourceId: PlannerResourceId | null = null;
  daysOfWeek: Array<DayOfWeek> = [];
  start!: Moment;
  end!: Moment;
  label = '';
}
